import { EpimsBaseEntityDto } from './epim-base.dto';

export class PlrstageactivityDto extends EpimsBaseEntityDto {
   
  PLStageId: string;
  Name:string;
  EstimatedDuration: string;
  SubscriberId: string;
  SiteId: string;
  ModifiedById: string;
  CreatedById: string;
  dateUpdated: Date;
  percentage: string;
  dateCreated: Date
 
  Version: string;

  PipelineId: string;

  StartDate: Date;
  EndDate: Date;
  PLStageActivityId: string;
  Status: string;
 PipelineLicenceRequestId: string;
 BatchId: string;
 RequestId: string;
}
